/** @jsxImportSource @emotion/react */

import { LoadingPageStyle } from "./style.index";

const LoadingPage = () => {
  return (
    <div css={LoadingPageStyle.wrapper}>
      <div
        id="overlay"
        style={{
          display: "block !important",
          position: "fixed",
          top: 0,
          left: 0,
          overflow: "auto",
          opacity: 1,
          background: "#FFF",
          zIndex: 99998,
          width: "100%",
          height: "100%",
        }}
      />
      <div
        id="spinner"
        style={{
          display: "block !important",
          position: "fixed",
          top: "50%",
          left: "50%",
          WebkitTransform: "translate(-50%)",
          msTransform: "translate(-50%)",
          transform: "translate(-50%)",
          zIndex: 99999,
        }}
      >
        <div style={{ color: "#000" }} className="la-ball-atom la-3x">
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
